import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useSearchParams } from 'react-router-dom';

import { Container, Typography, units } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';

const useStyles = makeStyles()(() => ({
  banner: {
    // Kamernet color
    backgroundColor: '#F3FBED',
    maxWidth: 'unset',
  },
  content: {
    maxWidth: units.rem(75),
    padding: units.yx(0.75, 0),
  },
}));

const KAMERNET = 'kamernet';

export function KamernetBanner() {
  const { T } = useIntl();
  const { classes } = useStyles();

  const [searchParams] = useSearchParams();
  const utmSource = searchParams.get('utm_source') ?? undefined;
  const isKamernet = utmSource === KAMERNET;

  if (!isKamernet) return null;

  return (
    <Container
      className={classes.banner}
      data-test-locator="Listing/banner/Kamernet"
    >
      <Container className={classes.content}>
        <Typography.ParagraphTitle>
          {T('ldp.welcome_banner.kamernet.title')}
        </Typography.ParagraphTitle>

        <Typography.Paragraph>
          {T('ldp.welcome_banner.kamernet.description_1')}
          <Typography.ParagraphTitle display="inline">
            {T('ldp.welcome_banner.kamernet.description_Kamernet')}
          </Typography.ParagraphTitle>
          {T('ldp.welcome_banner.kamernet.description_1_dot')}{' '}
          {T('ldp.welcome_banner.kamernet.description_2')}
        </Typography.Paragraph>
      </Container>
    </Container>
  );
}
